import { serviceRequest } from './service-request';

export function oAuthUserDetails(userCode: string) {
	return serviceRequest('svc/integration/oauth/user-details', { userCode });
}
